export default __webpack_public_path__ + "static/media/img6.da85754a.webp";